import Modal from 'react-bootstrap/Modal'

interface IModalProps {
    show: boolean
    onHide: () => void
    setGender: React.Dispatch<React.SetStateAction<string>>
}
const GenderModal = ({ show, onHide, setGender }: IModalProps) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <div className=" w-full text-center py-4 text-xs">
                <p className=" mb-3">جنیست خود را انتخاب کنید</p>
                <hr />
                <p
                    className=" text-green-1 my-2"
                    onClick={() => {
                        setGender('m')
                        onHide()
                    }}
                >
                    مرد
                </p>
                <hr />
                <p
                    className=" text-green-1 my-2"
                    onClick={() => {
                        setGender('f')
                        onHide()
                    }}
                >
                    زن
                </p>
                <hr />
                <p
                    className=" text-green-1 my-2"
                    onClick={() => {
                        setGender('o')
                        onHide()
                    }}
                >
                    سایر
                </p>
            </div>
        </Modal>
    )
}

export default GenderModal
